import { useEffect, useState } from 'react';
import styles, { global } from './styles';
import dynamic from 'next/dynamic';
import Modal from 'react-modal';

const DynamicReactPlayer = dynamic(() => import('react-player'), {
  ssr: false,
});

const TwoColumnsVideo = ({ block }) => {
  if (!block) return '';

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#242424',
      maxWidth: '800px',
      color: '#fff',
      padding: '20px',
      width: '90%',
      border: 'none',
      maxHeight: '90vh',
      overflow: 'auto',
      textAlign: 'center',
    },
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  // Show button state
  const [showButton, setShowButton] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const { primary } = block;
  const backgroundColour = primary?.background_colour
    ? primary.background_colour
    : '#000000';

  useEffect(() => {
    if (primary?.show_button !== undefined) {
      setShowButton(primary?.show_button);
    }
  }, []);

  useEffect(() => {
    let video_thumbnail;
    let videoId;
    if (primary.video_link != '') {
      videoId = primary.video_link
        .match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
        ?.pop();
      if (videoId?.length == 11) {
        video_thumbnail = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
      }
    }
  });

  return (
    <>
      <div className="container">
        <div
          className="section"
          style={
            primary.video_position == 'left'
              ? { flexDirection: 'row' }
              : { flexDirection: 'row-reverse' }
          }
        >
          <div
            className="video-section"
            style={
              primary.video_position == 'left'
                ? { marginRight: '5%' }
                : { marginLeft: '5%' }
            }
          >
            <DynamicReactPlayer
              className="react-player"
              url={primary.video_link}
              width="100%"
              height="100%"
              controls
            />
          </div>

          <div className="description-section">
            <p className="title">{primary.title1}</p>
            <p className="description">{primary.description}</p>
            {showButton === true && (
              <div className="video_button" onClick={openModal}>
                {primary.button_title}
              </div>
            )}
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Example Modal"
              style={customStyles}
            >
              <button
                onClick={closeModal}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: 'transparent',
                  color: '#fff',
                  fontSize: '20px',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <img
                  src={
                    'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close.png?v=1714038756'
                  }
                />
              </button>
              <h2 className="first_title">HOW TO ENTER?</h2>
              <p className="second_title">
                Launch your quest by uploading a TikTok video that encapsulates
                your journey and vision as a content creator. Introduce
                yourself, your passion, and your setup in a video of at least 60
                seconds, tagging @aftershockpcau and using
                #aftershockcreatorquest. You have one month to enter. Let your
                creativity flow!
              </p>
              <h2 className="first_title">WHO CAN ENTER?</h2>
              <p className="second_title">
                This contest is exclusively open to:
              </p>
              <ul>
                <li className="dot_list_inside second_title">
                  Australian residents who are 18 years of age and older.
                </li>
                <li className="dot_list_inside second_title">
                  Creators who have amassed 20,000 followers or less on TikTok,
                  providing a platform for up-and-coming talent.
                </li>
                <li className="dot_list_inside second_title">
                  Those whose content primarily focuses on technology and/or
                  gaming, ensuring a perfect match with Aftershock's passion for
                  these domains.
                </li>
              </ul>
              <h2 className="first_title">TERMS AND CONDITIONS OF CONTEST</h2>
              <ol className="second_title" style={{ textAlign: 'left' }}>
                <li className="second_title number_list">
                  Agreement to Terms: By placing an order with Aftershock, you
                  agree to be bound by these Terms and Conditions. If you do not
                  agree with any part of these terms, you must not place an
                  order.
                </li>
                <li className="second_title  number_list">
                  Order Process
                  <ul className="second_title">
                    <li className="second_title dot_list">
                      Customization: Customers can customize their PCs according
                      to the options provided on the Aftershock website.
                    </li>
                    <li className="second_title dot_list">
                      Confirmation: Once an order is placed, a confirmation
                      email will be sent to the customer. This email will
                      outline the details of the order and an estimated delivery
                      date.
                    </li>
                    <li className="second_title dot_list">
                      Payment: Full payment is required at the time of order
                      placement. Payment methods accepted include credit/debit
                      cards, PayPal, and bank transfers.
                    </li>
                  </ul>
                </li>
                <li className="second_title  number_list">
                  Pricing and Availability
                  <ul className="second_title">
                    <li className="second_title dot_list">
                      Pricing: All prices listed are in the specified currency
                      and inclusive of applicable taxes.
                    </li>
                    <li className="second_title dot_list">
                      Availability: Product availability is subject to change
                      without notice. In the event a component is unavailable,
                      Aftershock will notify the customer to select an
                      alternative.
                    </li>
                  </ul>
                </li>
                <li className="second_title  number_list">
                  Delivery
                  <ul className="second_title">
                    <li className="second_title dot_list">
                      Shipping: Aftershock offers shipping to specified regions.
                      Shipping costs are calculated at checkout and are borne by
                      the customer.
                    </li>
                    <li className="second_title dot_list">
                      Delivery Time: Estimated delivery times are provided at
                      the time of order confirmation. Aftershock is not
                      responsible for delays caused by external factors such as
                      shipping carrier issues or customs clearance.
                    </li>
                  </ul>
                </li>
                <li className="second_title  number_list">
                  Warranty and Returns
                  <ul className="second_title">
                    <li className="second_title dot_list">
                      Warranty: Aftershock PCs come with a specified warranty
                      period, covering parts and labor. The warranty does not
                      cover damage caused by misuse or unauthorized
                      modifications.
                    </li>
                  </ul>
                </li>
              </ol>
            </Modal>
          </div>
        </div>
      </div>
      <style jsx>{`
        .container {
          background: ${backgroundColour};
        }
      `}</style>
      <style jsx>{styles}</style>
      <style jsx>{global}</style>
    </>
  );
};

export default TwoColumnsVideo;
